import { Box, Typography, Chip, Avatar, Paper } from '@mui/material';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

// Karte eines einzelnen Highscores.
function HighscoreCard({ score }) {
    return (
        <Paper
            sx={{
                p: 2,
                width: "100%",
                background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
                borderRadius: '16px',
                border: '1px solid rgba(59, 130, 246, 0.3)',
                transition: 'all 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 16px rgba(59, 130, 246, 0.2)',
                    borderColor: 'rgba(59, 130, 246, 0.5)',
                },
            }}
        >
            {/* Header mit Icon */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar
                    sx={{
                        bgcolor: '#1e3a8a',
                        mr: 1.5,
                        width: 40,
                        height: 40,
                    }}
                >
                    <EmojiEventsIcon sx={{ color: '#3b82f6' }} />
                </Avatar>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={700}
                        color="#fff"
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {score.uebung_name || 'Unbekannte Übung'}
                    </Typography>
                    <Typography variant="caption" color="#93c5fd">
                        {score.zielmuskel || 'Unbekannt'}
                    </Typography>
                </Box>
            </Box>

            {/* Gewicht */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 3,
                    px: 2,
                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                    borderRadius: '16px',
                    mb: 2,
                }}
            >
                <FitnessCenterIcon
                    sx={{ color: '#3b82f6', fontSize: 32, mr: 1.5 }}
                />
                <Typography
                    variant="h4"
                    fontWeight={700}
                    color="#3b82f6"
                >
                    {score.max_gewicht || 0}
                </Typography>
                <Typography
                    variant="h6"
                    color="#93c5fd"
                    sx={{ ml: 0.5 }}
                >
                    kg
                </Typography>
            </Box>

            {/* Nutzer Info */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography variant="body2" color="#93c5fd">
                    Erreicht von
                </Typography>
                <Chip
                    label={`${score.vname || ''} ${score.nname || ''}`.trim() || 'Unbekannt'}
                    size="small"
                    sx={{
                        backgroundColor: '#1e3a8a',
                        color: '#e0f2fe',
                        fontWeight: 600,
                    }}
                />
            </Box>
        </Paper>
    );
}

export default HighscoreCard;
